export const friendData = [
  {
    "first": "Heath",
    "last": "Richmond",
    "age": 27,
    "isBestFriend": true
  },
  {
    "first": "Cox",
    "last": "Estrada",
    "age": 27,
    "isBestFriend": true
  },
  {
    "first": "Norma",
    "last": "Mccoy",
    "age": 35,
    "isBestFriend": false
  },
  {
    "first": "Wallace",
    "last": "Montoya",
    "age": 27,
    "isBestFriend": false
  },
  {
    "first": "Concepcion",
    "last": "Mccarthy",
    "age": 22,
    "isBestFriend": true
  },
  {
    "first": "Albert",
    "last": "Wade",
    "age": 25,
    "isBestFriend": true
  },
  {
    "first": "Sykes",
    "last": "Gonzalez",
    "age": 29,
    "isBestFriend": false
  },
  {
    "first": "Alisa",
    "last": "Ryan",
    "age": 30,
    "isBestFriend": true
  },
  {
    "first": "Holmes",
    "last": "Bright",
    "age": 28,
    "isBestFriend": false
  },
  {
    "first": "Estrada",
    "last": "Pittman",
    "age": 25,
    "isBestFriend": false
  }
];



// WEBPACK FOOTER //
// ./src/data/friends.js